/* eslint-disable no-unused-vars */
import AccordionItem from "./AccordionItem";
import AnnotationList from "./AnnotationList";
import Annotation from './Annotation';

function HotSpots() {

  return (
    <div >
      <AccordionItem header="HotSpots">
        <Annotation />
        <AnnotationList header="Annotation Hotspots" listType={0} />
        <AnnotationList header="Animation Hotspots" listType={1} />
      </AccordionItem>

    </div>
  );
}

export default HotSpots;
